import af from './af';
import en from './en';

export default {
  af,
  en,
};
